export default {
    title:`CONGRATS, IT’S A MATCH!`,
    h1:`Call, text, or email that person right now because you both like each other!`,
    h3:`You can’t see us, but we’re doing a happy dance right now. You probably are, too. We’re genuinely excited for you and know there are lots of great things to come. 
We love to hear success stories, so come back to share yours with us. And if you have family or friends who you think could benefit from CrushPledge, send them our way. 
Again, congratulations!`,
    done:`Good luck!`
}


// WEBPACK FOOTER //
// ./assets/strings/success.js